import { IoCameraOutline, IoChevronBack, IoClose } from "react-icons/io5";
import { useState, useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Analytics,Gtag } from '../compornents/Analytics';
import { Stepper } from "baseui/stepper";

export const Option = () => {
  const navigate = useNavigate();
  let location = useLocation();
  let data = location.state?.data || {item:{},quote:{},options:[]};
  let option_category = location.state?.option_category || [];
  let option = location.state?.option;
  const [suu, setSuu] = useState(data.options === undefined ? 0 : data.options.find(o => o.id === option.id)?.suu || 0);

  const [uploadedImages, setUploadedImages] = useState({});
  const fileInputRef = useRef(null);

  // ボタンクリック
  const handleButtonClick = () => {
    // console.log("Button clicked");
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };
  // 戻る。一覧をスキップして来た場合（カテゴリ配下1件）はカテゴリ一覧へ戻す。
  const back = () => {
    if (location.state?.skipList) {
      navigate("/option_category", { state: { data:data } });
    } else {
      navigate("/options", { state: { data:data,option_category:option_category } });
    }
  };

  // ホームへ
  const toHome = () => {
    navigate("/home");
  };

  // 撮影した写真を保存
  const handlePhotoUpload = (event, optionId) => {
    const files = Array.from(event.target.files);
    if (files.length === 0) return;

    const currentImages = uploadedImages[optionId] || [];
    const remainingSlots = suu - currentImages.length;
    const filesToProcess = files.slice(0, remainingSlots); // suu上限を超えないように

    const newImages = filesToProcess.map(file => ({
      file,
      preview: URL.createObjectURL(file),
    }));

    setUploadedImages(prev => ({
      ...prev,
      [optionId]: [...(prev[optionId] || []), ...newImages],
    }));

    if (files.length > remainingSlots) {
      alert(`写真は最大 ${suu} 枚までアップロードできます`);
    }

    // 同じ画像を選び直しても反応するように
    event.target.value = null;
  };


  // 撮影した写真を削除
  const handleRemoveImage = (optionId, index) => {
    setUploadedImages(prev => {
      const updated = [...(prev[optionId] || [])];
      updated.splice(index, 1);
      return {
        ...prev,
        [optionId]: updated,
      };
    });
  };

  // オプションを追加
  function addOption() {
    option.suu = suu;
    option.images = uploadedImages[option.id] || [];

    if (data.options === undefined) {
      data.options = [];
    }

    const existingOptionIndex = data.options.findIndex(o => o.id === option.id);

    if (existingOptionIndex !== -1) {
      if (suu <= 0) {
        // 数量が0なら削除
        data.options.splice(existingOptionIndex, 1);
      } else {
        // 数量と画像を更新
        data.options[existingOptionIndex].suu = suu;
        data.options[existingOptionIndex].images = option.images;
      }
      setSuu(0);
      navigate("/option_category", { state: { data: data } });
      return;
    }
    if (suu <= 0) {
      // 数量が0なら何もしない
      return;
    }
    // 新しいオプションを追加
    data.options.push({ ...option }); // クローンで追加
    navigate("/option_category", { state: { data: data } });
  }


  useEffect(() => {
    // ページトップ
    setTimeout(() => {
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
      window.scrollTo(0, 0); // 念のため併用
    }, 10);
    Gtag('view_option');
    if (location.state === null || location.state.data === undefined) {
      navigate("/home");
    }
    // data.options から画像を復元
    if (data.options && option?.id) {
      const found = data.options.find(o => o.id === option.id);
      if (found && found.images && found.images.length > 0) {
        setUploadedImages(prev => ({
          ...prev,
          [option.id]: found.images
        }));
      }
    }

  }, [data?.options, option?.id,location, navigate]);
  return (
    <div className="App">
      <div className="Confirm">
        <Analytics title={option?.name || "オプション"} />
        <div className="toolbar">
          <div className="toolbar_left">
            <div className="">
              <IoChevronBack onClick={back} />
            </div>
          </div>
          <div className="toolbar_center">
            {option?.name}
          </div>
          <div className="toolbar_right">
            <IoClose onClick={toHome} />
          </div>
        </div>
        <div className="mb-2 border-bottom"></div>
        <div className="content">
          <div className="h4 mb-2">{option?.name}</div>
          <div className="">
            <img src={option?.img} className="ItemImage" alt="Item" />
          </div>
          <div>
            <div className="row align-items-center">
              <div className="col-6 h5">
                <div className="mt-1">
                  <small className="mr-2">1点</small>¥{Number(option?.kin2).toLocaleString()}
                  <small className="ml-2">(税込)</small>
                </div>
              </div>
              <div className="col-6 text-right d-flex justify-content-end">
                <Stepper
                  value={suu}
                  setValue={newValue => setSuu(newValue)}
                />
              </div>
            </div>
          </div>

          {/* 撮影セクションの追加 */}
          <div className="mt-3">
            <button onClick={handleButtonClick} className="btn btn-oval btn-outline-secondary form-control">
              <IoCameraOutline className="mt-1 mr-1" /> 対象商品の写真を撮る
            </button>
            <input
              type="file"
              ref={fileInputRef}
              id={`upload-${option?.id}`}
              accept="image/*"
              capture="environment"
              multiple
              style={{ display: "none" }}
              onChange={e => handlePhotoUpload(e, option?.id)}
            />
          </div>
          {uploadedImages[option?.id]?.length > 0 && (
            <div className="mt-2 d-flex flex-wrap">
              {uploadedImages[option?.id].map((img, index) => (
                <div key={index} className="position-relative mr-2 mb-2">
                  <img
                    src={img.preview}
                    alt={`Preview ${index + 1}`}
                    className="img-fluid rounded"
                    style={{ maxHeight: "150px" }}
                  />
                  <button
                    type="button"
                    onClick={() => handleRemoveImage(option?.id, index)}
                    className="btn btn-sm btn-danger position-absolute"
                    style={{
                      top: 0,
                      right: 0,
                      borderRadius: "50%",
                      padding: "2px 6px",
                      lineHeight: "1",
                    }}
                  >
                    ×
                  </button>
                </div>
              ))}
            </div>
          )}

          <div className="pre mt-3">
            {option?.detail}
          </div>
        </div>
        <div className="flex_div3 border-top">
          <div className="p-3 pb-4">
              {suu > 0 ? (
                <button className="btn btn-oval btn-yellow form-control" onClick={addOption}>
                  決定する
                </button>
              ) : (
                <button className="btn btn-oval btn-gray form-control" onClick={addOption}>
                  決定する
                </button>
              )}

          </div>
        </div>
      </div>
    </div>
  );
}
